global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
window.Swiper = Swiper;

import AOS from 'aos';
import 'aos/dist/aos.css';

$(document).ready(function() {

    AOS.init({
        delay: 400,
        duration: 800,
        once: true,
    });

    // Burger toggle open/close
    const headerOverlay = $('.header__overlay');
    const closerX = $('#closerX');
    // sticky scroll menu
    const header = $('header');
    let offSet = $('.home-background-video').innerHeight()
    let fromTop = ($(window).scrollTop())

    let beforeAfterImg =$('.box-before-after .img');
    beforeAfterImg.css('background-size' , $(".box-before-after").width()+'px')
    window.onresize = function() {
        offSet = $('.home-background-video').innerHeight()
        beforeAfterImg.css('background-size' , $(".box-before-after").width()+'px')
        setHead()
    }
    setHead()
    function setHead(){
        header.removeClass('header--std');
        if (header.attr('data-type') === 'header--home') {
            if (fromTop >= offSet){
                header.removeClass(header.attr('data-type'));
            } else {
                header.addClass(header.attr('data-type'));
            }
            window.onscroll = function () {
                fromTop = ($(window).scrollTop())
                if (fromTop >= offSet){
                    header.removeClass(header.attr('data-type'));
                    header.addClass('header--std');
                } else {
                    header.addClass(header.attr('data-type'));
                    header.removeClass('header--std');
                }
            };
        } else {
            header.addClass('header--std');
        }
    }

    if($('.headroom').length > 0){
        let headroomEl = document.querySelector("header");
        let options = {
            offset : 100,
        }
        let headroom  = new Headroom(headroomEl,options);
        headroom.init();
    }

    headerOverlay.click(function (e) {
        toggleMenuOpenClose();
    })

    closerX.click(function (e) {
        toggleMenuOpenClose();
    })

    // burger menu effect button
    let burgerButton = $('.burger-button');
    burgerButton.on('click', function(e) {
        e.preventDefault();
        toggleMenuOpenClose();
    });

    function toggleMenuOpenClose() {
        let body = $('body');
        let headerNavWrapper = $('.header__nav-wrapper');
        if (headerNavWrapper.hasClass('open')) {
            body.removeClass('no-scroll-y');
            headerNavWrapper.removeClass('open');
            headerOverlay.removeClass('open');
        } else {
            body.addClass('no-scroll-y');
            headerNavWrapper.addClass('open');
            headerOverlay.addClass('open');
        }
        $('#burger-button i').toggleClass("fa-bars fa-x");
    }

    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });

    $("#slider").on("input change", (e)=>{
        const sliderPos = e.target.value;
        // Update the width of the foreground image
        $('.foreground-img').css('width', `${sliderPos}%`)
        // $('.background-img').css('width', `${sliderPos}%`)
        // Update the position of the slider button
        $('.slider-button').css('left', `calc(${sliderPos}% - 16px)`)
        $('.slider-bar').css('left', `${sliderPos}%`)
    });

    // Switch dei form tramite select
    let formProdotto = $('div #prodotto');
    let formPreventivo = $('div #preventivo');
    let formSuMisura = $('#su-misura');
    $('#form').on('change', function (){
        let name = $('#form option:selected').val();
        if (name == "prodotto"){
            formProdotto.addClass('d-block')
            formProdotto.removeClass('d-none')
            formPreventivo.addClass('d-none');
            formSuMisura.addClass('d-none');
        }else if(name == "preventivo"){
            formPreventivo.addClass('d-block')
            formPreventivo.removeClass('d-none')
            formProdotto.addClass('d-none');
            formSuMisura.addClass('d-none');
        }else if(name == "su-misura"){
            formSuMisura.addClass('d-block')
            formSuMisura.removeClass('d-none')
            formProdotto.addClass('d-none');
            formPreventivo.addClass('d-none');
        }
    });

    $("#sitePicker").hover(function(e){
        $(".sitePicker").addClass("show");
    },function(e){
        $(".sitePicker").removeClass("show");
    });

    $("#sitePickerMobile").hover(function(e){
        $(".sitePickerMobile").addClass("show");
    },function(e){
        $(".sitePickerMobile").removeClass("show");
    });


});
